import React, { useRef, useState, useEffect } from "react";
import { InfoCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, Space, Spin, Table, message } from "antd";
import { Link } from "react-router-dom";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useSelector } from "react-redux";
import SendIcon from "@mui/icons-material/Send";
import firebase from "../../config/firebase";
import mdfeService from "../../service/mdfe.service";
import axios from "axios";
import RetornoMdfeModal from "../alert-mdfe/alert-mdfe-retorno";
import AddToPhotosRoundedIcon from "@mui/icons-material/AddToPhotosRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate, useParams } from "react-router-dom";

import PlaylistAddCheckCircleSharpIcon from "@mui/icons-material/PlaylistAddCheckCircleSharp";
import UnpublishedTwoToneIcon from "@mui/icons-material/UnpublishedTwoTone";
import CancelScheduleSendSharpIcon from '@mui/icons-material/CancelScheduleSendSharp';

import Chip from '@mui/material/Chip';

import InfoIcon from "@mui/icons-material/Info";
import { background } from "@chakra-ui/react";
require("firebase/auth");

const DataMdfeCompTable = () => {
  let navigate = useNavigate();

  const user = useSelector((state) => state.user);

  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(true);
  const [mensagem, setMensagem] = useState("");
  const [status, setStatus] = useState("");
  const [title, setTitle] = useState("");

  const [open, setOpen] = useState(false);


  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const [openSnackbar, setOpenSnackbar] = useState(false);



  useEffect(() => {
    setLoading(true);
    const unsubscribe = firebase
      .firestore()
      .collection("tb_mdfe")
      .onSnapshot(
        (querySnapshot) => {
          const novaLista = [];
          querySnapshot.forEach((doc) => {
            novaLista.push({ id: doc.id, ...doc.data() });
          });


          novaLista.sort((a, b) => {
            /**
             * Função que retorna um valor de prioridade baseado no status do MDF-e.
             * 
             * @param {Object} record - Registro do MDF-e.
             * @returns {Number} - Valor de prioridade.
             * - 1 se o status for "autorizado"
             * - 2 se o status for diferente de "autorizado" e "cancelado"
             * - 3 se o status for "encerrado"
             * - 4 se o status for "cancelado"
             */
            const getPeso = (record) => {
              const dados = record.retornoSefaz || {};


              const isCancelado = !!dados.canceledMdfe;
              const isEncerrado = !!dados.mdfeFinished;
              const isAutorizadoStatus = dados.status === "autorizado";

              if (isCancelado) return 4;

              if (isEncerrado) return 3;

              if (isAutorizadoStatus) return 1;

              return 2;
            };

            const pesoA = getPeso(a);
            const pesoB = getPeso(b);

            // Se os pesos forem diferentes, ordena pelo peso
            if (pesoA !== pesoB) {
              return pesoA - pesoB;
            }


            const dataA = a.infMDFe?.ide?.dhEmi?.toDate ? a.infMDFe.ide.dhEmi.toDate() : 0;
            const dataB = b.infMDFe?.ide?.dhEmi?.toDate ? b.infMDFe.ide.dhEmi.toDate() : 0;
            return dataB - dataA;
          });


          setData(novaLista);
          setLoading(false);
        },
        (error) => {
          console.error("Erro ao ouvir coleção: ", error);
          setLoading(false);
        }
      );

    return () => unsubscribe();
  }, []);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length > 0) {
      if (selectedKeys[0].trim().length > 0) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      } else {
        confirm();
        setSearchText("");
        setSearchedColumn(dataIndex);
      }
    } else {
      confirm();
      setSearchText("");
      setSearchedColumn(dataIndex);
    }
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  function deleteMdfe(id) {
    var result = window.confirm("Deseja mesmo excluir esse MDFe ? ");

    if (result === true) {
      firebase
        .firestore()
        .collection("tb_mdfe")
        .doc(id)
        .delete()
        .then(() => {
          setMensagem("Manifesto excluído com sucesso!");
          setOpen(true);
          setLoading(false);
          setTitle("Manifesto excluído");
          setStatus("success");
          setTimeout(() => {
            navigate("/listMdfe");
          }, 2000);
        })
        .catch((error) => {
          setTitle("Erro ao excluir MDFe");
          setStatus("error");
          setMensagem("Erro ao excluir MDFe: " + error.message);
          setOpen(true);
          setLoading(false);
        });
    }
  }


  /**
   * Formata um timestamp para uma string no formato
   * dd/MM/yyyy 
   * Se o parâmetro for inválido, retorna "Data inválida".
   * @param {Timestamp} timestamp - O timestamp a ser formatado.
   * @returns {string} - A string no formato dd/MM/yyyy 
   */
  const formatarTimestamp = (timestamp) => {
    if (timestamp && typeof timestamp.toDate === 'function') {
      const data = timestamp.toDate();
      return data.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',

      });
    }
    return "Data inválida";
  };


  const formatarData = (data) => {
    if (!data) return "";
    return data.split('-').reverse().join('-');
  };

  const getInformation = (id) => {
    const mdfeRef = firebase.firestore().collection("tb_mdfe").doc(id);
    mdfeRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          const data = doc.data();
          debugger
          if (!data.retornoSefaz || !data.retornoSefaz.autorizacao) {
            setMensagem("Ainda não há status disponível para este MDF-e.");
            setTitle("Status: Iniciado");
            setStatus("error");
            setOpen(true);
            return;
          }

          if (data.retornoSefaz.canceledMdfe) {
            setMensagem("O MDF-e já foi cancelado ");
            setTitle(" Cancelado");
            setStatus("Cancelado");
            setOpen(true);
            return;
          }


          if (data.retornoSefaz.mdfeFinished) {
            setMensagem("O MDF-e já foi encerrado em " + formatarData(data.retornoSefaz.mdfeFinished.data_encerramento));
            setTitle("Encerrado");
            setStatus("Encerrado");
            setOpen(true);
            return;
          }

          setMensagem(
            `Motivo: ${data.retornoSefaz?.autorizacao.motivo_status ||
            "Nenhum motivo informado"
            }\n`
          );
          setTitle("Status: " + data.retornoSefaz.status);
          setStatus(
            data.retornoSefaz.status === "autorizado"
              ? "success"
              : "error"
          );
          setOpen(true);
        }
      })
      .catch((error) => {
        setMensagem(`error: ${error.message}`);
        setTitle("Status: Erro ao buscar informações");
        setStatus("error");
        setOpen(true);
      });
  };

  // Função de validação do JSON para envio de MDF-e
  // utils de validação
  function apenasNumerico(valor) {
    return /^\d+$/.test(valor);
  }

  function validarTamanho(valor, min, max) {
    return valor && valor.length >= min && valor.length <= max;
  }

  function placaValida(placa) {
    const antiga = /^[A-Z]{3}[0-9]{4}$/;
    const mercosul = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/;
    return antiga.test(placa) || mercosul.test(placa);
  }

  // função principal
  function validarMDFe(mdfe) {
    const erros = [];

    const {
      cUF,
      tpAmb,
      tpEmit,
      tpTransp,
      mod,
      serie,
      nMDF,
      cMDF,
      cDV,
      modal,
      dhEmi,
      tpEmis,
      procEmi,
      verProc,
      UFIni,
      UFFim,
    } = mdfe.infMDFe.ide;

    if (!cUF || String(cUF).length !== 2)
      erros.push("cUF deve ter 2 dígitos numéricos.");
    if (![1, 2].includes(tpAmb))
      erros.push("tpAmb deve ser 1 (produção) ou 2 (homologação).");
    if (![1, 2].includes(tpEmit))
      erros.push("tpEmit deve ser 1 (prestador) ou 2 (contratado).");
    if (![1, 2].includes(tpTransp))
      erros.push(
        "tpTransp deve ser 1 (carga própria) ou 2 (prestação de serviço)."
      );
    if (mod !== 58) erros.push("mod deve ser '58'.");
    if (!Number.isInteger(serie) || serie < 1 || serie > 999)
      erros.push("serie deve ser número entre 1 e 999.");
    if (!Number.isInteger(nMDF) || nMDF <= 0)
      erros.push("nMDF deve ser número positivo.");
    if (!cMDF || String(cMDF).length !== 8)
      erros.push("cMDF deve ter 8 dígitos.");
    if (!cDV || String(cDV).length !== 1) erros.push("cDV deve ter 1 dígito.");
    if (!["1", "2", "3", "4"].includes(String(tpEmis)))
      erros.push("tpEmis inválido (1-Normal, 2-Contingência, etc.).");
    if (!procEmi) erros.push("procEmi é obrigatório.");
    if (!verProc) erros.push("verProc é obrigatório.");
    if (!UFIni || UFIni.length !== 2)
      erros.push("UFIni deve ter 2 caracteres.");
    if (!UFFim || UFFim.length !== 2)
      erros.push("UFFim deve ter 2 caracteres.");
    if (!dhEmi) erros.push("dhEmi é obrigatório.");

    const { CNPJ, IE, xNome, xFant, enderEmit } = mdfe.infMDFe.emit;

    if (!CNPJ || !/^\d{14}$/.test(CNPJ))
      erros.push("CNPJ deve ter 14 dígitos.");
    if (!IE || !apenasNumerico(IE)) erros.push("IE deve ser numérico.");
    if (!validarTamanho(xNome, 2, 60))
      erros.push("xNome deve ter entre 2 e 60 caracteres.");
    if (xFant && xFant.length > 60)
      erros.push("xFant deve ter até 60 caracteres.");

    const isEmpty = (value) => {
      return value === null || value === undefined || value === "";
    };

    const { xLgr, nro, xBairro, cMun, xMun, CEP, UF, fone, email } = enderEmit;

    if (isEmpty(xLgr)) erros.push("Logradouro do emitente é obrigatório.");
    if (isEmpty(nro)) erros.push("Número do emitente é obrigatório.");
    if (isEmpty(xBairro)) erros.push("Bairro do emitente é obrigatório.");

    // cMun: precisa existir + ser numérico
    if (isEmpty(cMun)) {
      erros.push("Código do municipio do emitente é obrigatório.");
    } else if (!apenasNumerico(cMun)) {
      erros.push("Código do municipio do emitente deve ser numérico.");
    }

    if (isEmpty(xMun)) erros.push("Municipio do emitente é obrigatório.");

    // CEP: precisa existir + ter 8 dígitos
    if (isEmpty(CEP)) {
      erros.push("CEP do emitente é obrigatório.");
    } else if (!/^\d{8}$/.test(CEP)) {
      erros.push("CEP do emitente deve ter 8 dígitos.");
    }

    // UF: precisa existir + ter 2 caracteres
    if (isEmpty(UF)) {
      erros.push("UF do emitente é obrigatório.");
    } else if (UF.length !== 2) {
      erros.push("UF do emitente deve ter 2 caracteres.");
    }

    // fone: só valida se foi informado
    if (isEmpty(fone)) {
      erros.push("Obrigatório informar um número de telefone para o emitente");
    } else if (!apenasNumerico(fone)) {
      erros.push("fone deve ser numérico.");
    }

    // email: só valida se foi informado
    if (!isEmpty(email) && !/.+@.+\..+/.test(email)) {
      erros.push("Obrigatório informar um e-mail válido para o emitente");
    }

    const { infANTT, veicTracao, veicReboque } = mdfe.infMDFe.infModal.rodo;

    if (!infANTT.RNTRC || !/^\d{8,12}$/.test(infANTT.RNTRC))
      erros.push("RNTRC deve ter de 8 a 12 dígitos.");
    if (!infANTT.infContratante || infANTT.infContratante.length === 0) {
      erros.push("infContratante é obrigatório.");
    }

    infANTT.infPag.forEach((p, i) => {
      if (!p.CNPJ || !/^\d{14}$/.test(p.CNPJ))
        erros.push(`infPag[${i}].CNPJ inválido.`);
      if (!p.xNome) erros.push(`infPag[${i}].xNome é obrigatório.`);
      if (!p.vContrato || isNaN(p.vContrato))
        erros.push(`infPag[${i}].vContrato deve ser numérico.`);
      if (![0, 1].includes(p.indPag))
        erros.push(`infPag[${i}].indPag deve ser 0 (à vista) ou 1 (a prazo).`);
      // if (p.Comp) {
      //   p.Comp.forEach((c, j) => {
      //     if (!c.tpComp)
      //       erros.push(`infPag[${i}].Comp[${j}].tpComp obrigatório.`);
      //     if (isNaN(c.vComp))
      //       erros.push(`infPag[${i}].Comp[${j}].vComp deve ser numérico.`);
      //   });
      // }
      if (p.infPrazo) {
        p.infPrazo.forEach((prazo, k) => {
          if (!prazo.nParcela)
            erros.push(`infPag[${i}].infPrazo[${k}].nParcela obrigatório.`);
          if (!prazo.dVenc)
            erros.push(`infPag[${i}].infPrazo[${k}].dVenc obrigatório.`);
          if (isNaN(prazo.vParcela))
            erros.push(
              `infPag[${i}].infPrazo[${k}].vParcela deve ser numérico.`
            );
        });
      }
    });

    // === Validação do veículo de tração (cavalo mecânico)
    if (!veicTracao) {
      erros.push("veículo tração é obrigatório.");
    } else {
      if (!veicTracao.placa || !placaValida(veicTracao.placa)) {
        erros.push("Placa do veículo tração no formato inválida.");
      }
      if (!veicTracao.RENAVAM || !/^\d{9,11}$/.test(veicTracao.RENAVAM)) {
        erros.push("RENAVAM do veículo tração deve ter entre 9 e 11 dígitos.");
      }

      if (typeof veicTracao.tara === "string") {
        erros.push("Tara do veículo tração deve ser numérico.");
      }

      if (typeof veicTracao.capKG === "string") {
        erros.push("O Campo capKG do veículo tração deve ser numérico.");
      }

      if (typeof veicTracao.capM3 === "string") {
        erros.push("O Campo capM3 do veículo tração deve ser numérico.");
      }

      const { CNPJ, CPF, RNTRC, xNome, IE, UF, tpProp } = veicTracao.prop;
      if (!CNPJ && !CPF)
        erros.push("Proprietário do veicTracao deve ter CNPJ ou CPF.");
      if (CNPJ && !/^\d{14}$/.test(CNPJ))
        erros.push("CNPJ do proprietário do veicTracao inválido.");
      if (CPF && !/^\d{11}$/.test(CPF))
        erros.push("CPF do proprietário do veicTracao inválido.");
      if (!RNTRC || !/^\d{8,12}$/.test(RNTRC))
        erros.push(
          "RNTRC do proprietário do veicTracao deve ter 8 a 12 dígitos."
        );
      if (!xNome)
        erros.push("Nome do proprietário do veicTracao é obrigatório.");
      if (![0, 1, 2].includes(tpProp))
        erros.push(
          "Tipo proprietário do veículo tração deve ser 0 (Outros), 1 (TAC), 2 (ETC)."
        );
    }

    if (veicReboque && veicReboque.length > 0) {
      veicReboque.forEach((reb, i) => {
        if (!reb.cInt) erros.push(`cInt do veicReboque[${i}] é obrigatório.`);
        if (!reb.placa || !placaValida(reb.placa)) {
          erros.push(`Placa do reboque[${i}] inválida (padrão AAA9999).`);
        }
        if (!reb.RENAVAM || !/^\d{9,11}$/.test(reb.RENAVAM)) {
          erros.push(`RENAVAM do reboque[${i}] deve ter entre 9 e 11 dígitos.`);
        }

        if (typeof reb.tara === "string") {
          erros.push(
            `O Campo tara do veículo reboque[${i}] deve ser numérico.`
          );
        }

        if (typeof reb.capKG === "string") {
          erros.push(
            `O Campo capKG do veículo reboque[${i}] deve ser numérico.`
          );
        }

        if (typeof reb.capM3 === "string") {
          erros.push(
            `O Campo capM3 do veículo reboque[${i}] deve ser numérico.`
          );
        }

        if (reb.prop) {
          const { CNPJ, CPF, RNTRC, xNome, IE, UF, tpProp } = reb.prop;
          if (!CNPJ && !CPF)
            erros.push(
              `Proprietário do veicReboque[${i}] deve ter CNPJ ou CPF.`
            );
          if (CPF && !/^\d{11}$/.test(CPF))
            erros.push(`CPF do proprietário do veicReboque[${i}] inválido.`);
          if (!RNTRC || !/^\d{8,12}$/.test(RNTRC))
            erros.push(
              `RNTRC do proprietário do veicReboque[${i}] deve ter 8 a 12 dígitos.`
            );
          if (!xNome)
            erros.push(
              `Nome do proprietário do veicReboque[${i}] é obrigatório.`
            );
          if (![0, 1, 2].includes(tpProp))
            erros.push(
              `tpProp do veicReboque[${i}] deve ser 0 (Outros), 1 (TAC), 2 (ETC).`
            );
        }
      });
    }

    const { cMunDescarga, xMunDescarga, infNFe } =
      mdfe.infMDFe.infDoc.infMunDescarga[0];

    if (cMunDescarga === "")
      erros.push(
        `Código do municipio precisa está prerenchido na aba Documentos`
      );
    if (xMunDescarga === "")
      erros.push(
        `Nome do municipio precisa está prerenchido na aba Documentos`
      );
    if (infNFe[0].chNFe === "")
      erros.push(`Nota fiscal precisa está prerenchido na aba Documentos`);

    const { NCM, infLotacao, tpCarga, xProd } = mdfe.infMDFe.prodPred;

    if (tpCarga === "")
      erros.push(
        `Tipo da carga precisa ser prerenchido na aba Produtos predominantes`
      );
    if (xProd === "")
      erros.push(
        `Descrição do produto precisa ser prerenchido na aba Produtos predominantes`
      );
    if (infLotacao.infLocalCarrega.CEP === "")
      erros.push(
        `CEP do local de carregamento precisa ser prerenchido na aba Produtos predominantes`
      );
    if (infLotacao.infLocalDescarrega.CEP === "")
      erros.push(
        `CEP do local de Descarga precisa ser prerenchido na aba Produtos predominantes`
      );
    if (!/^\d{8}$/.test(infLotacao.infLocalDescarrega.CEP))
      erros.push(
        `CEP do local de Descarga precisa ser está no formado inválido`
      );

    return {
      valido: erros.length === 0,
      erros,
    };
  }

  const cancelMdfe = async (Mdfe) => {
    const data = {

      "justificativa": "teste para cancelamento",
    };

    const resposta = await axios.post(
      `https://api-fortio-integr-nuvem-fiscal-323958413561.us-central1.run.app/api/mdfe/${Mdfe.retornoSefaz.id}/cancelamento`,
      data
    );

    if (resposta.status === 200) {

      updateMdfeCancel(resposta.data, Mdfe.id);
      setTitle("Erro ao enviar MDF-e");
      setStatus("error");
      setMensagem("Erro ao enviar MDFe: " + resposta.data);
      setOpen(true);
    } else {
      setTitle("Erro ao enviar MDF-e");
      setStatus("error");
      setMensagem("Erro ao enviar MDFe: " + resposta.data);
      setOpen(true);
    }



  };


  function updateMdfeCancel(data, idMdfe) {
    const canceledMdfe = {
      id: data?.id ? data.id : 0,
      justificativa: data?.justificativa ? data.justificativa : "",
      ambiente: data?.ambiente ? data.ambiente : "",
      status: data?.status ? data.status : "",
      autor: {
        cpf_cnpj: data?.autor?.cpf_cnpj ? data.autor.cpf_cnpj : "",
      },
      chave_acesso: data?.chave_acesso ? data.chave_acesso : "",
      data_evento: data?.data_evento ? data.data_evento : "",
      numero_sequencial: data?.numero_sequencial ? data.numero_sequencial : 0,
      data_recebimento: data?.data_recebimento ? data.data_recebimento : "",
      codigo_status: data?.codigo_status ? data.codigo_status : "",
      motivo_status: data?.motivo_status ? data.motivo_status : "",
      numero_protocolo: data?.numero_protocolo ? data.numero_protocolo : "",
      tipo_evento: data?.tipo_evento ? data.tipo_evento : "",
      data_cancelamento: data?.data_cancelamento ? data.data_cancelamento : "",
      mensagem: data?.mensagem ? data.mensagem : "",
      codigo_mensagem: data?.codigo_mensagem ? data.codigo_mensagem : "",
    };



    const mdfeRef = firebase.firestore().collection("tb_mdfe").doc(idMdfe);

    mdfeRef
      .update({
        "retornoSefaz.canceledMdfe": canceledMdfe,
      })
      .then(() => {
        console.log("MDF-e cancelado com sucesso!");

        setTitle("MDF-e cancelado com sucesso!");
        setStatus("success");
        setMensagem("MDF-e cancelado  com sucesso!");
        setOpen(true);
      })
      .catch((error) => {
        console.log("Erro ao cancelar MDF-e: ", error);
        setTitle("Erro ao cancelar MDF-e");
        setStatus("error");
        setMensagem("Erro ao cancelar MDFe: " + error);
        setOpen(true);
      });
  }

  const finishMdfe = async (Mdfe) => {


    try {
      const resposta = await mdfeService.finishMdfe(Mdfe);

      if (resposta.status === 200) {



        updateMdfeFinished(resposta.data, Mdfe.id);

        setTitle("Sucesso!");
        setStatus("success");
        setMensagem("O MDF-e foi encerrado com sucesso.");
        setOpen(true);
      } else {
        setTitle("Erro ao enviar MDF-e");
        setStatus("error");
        setMensagem("Erro ao enviar MDFe: " + resposta.data);
        setOpen(true);
      }
      console.log("Todos os campos são válidos!");

      console.log("Finalizando MDF-e...  ", resposta.data);
    } catch (error) {
      console.error("Erro inesperado na função finishMdfe:", error);
      setTitle("Erro Crítico de Conexão");
      setStatus("error");
      setMensagem("Não foi possível conectar ao servidor. Tente novamente.");
      setOpen(true);
    }


  };

  /**
   * Função para atualizar o status do MDF-e
   * @param {Object} data - Dados para atualizar o MDF-e
   * @param {string} idMdfe - ID do MDF-e
   * @returns {Promise} - Resultado da atualização do MDF-e
   */
  async function updateMdfeFinished(data, idMdfe) {

    const res = await mdfeService.updateMdfeFinished(data, idMdfe);


    if (res.status === 200) {
      setTitle("MDF-e encerrado com sucesso!");
      setStatus("success");
      setMensagem("MDF-e encerrado  com sucesso!");
      setOpen(true);
    } else {
      setTitle("Erro ao encerrar MDF-e");
      setStatus("error");
      setMensagem("Erro ao encerrar MDFe: " + res.data);
      setOpen(true);
    }

  }

  const sendMdfe = async (idMdfe) => {
    setLoading(true);

    try {
      console.log("Enviando MDF-e...");
      setLoading(true);

      const data = await mdfeService.sendMdfe(idMdfe);

      const errors = validarMDFe(data);


      // data.infMDFe.infModal.rodo.infANTT.infContratante[0].xNome = data.infMDFe.infModal.rodo.infANTT.infContratante[0].xNome.trim();
      // data.infMDFe.emit.xFant = data.infMDFe.emit.xFant.trim();
      data.infMDFe.infDoc.infMunDescarga[0].infNFe[0].chNFe =
        data.infMDFe.infDoc.infMunDescarga[0].infNFe[0].chNFe.replace(
          /\s/g,
          ""
        );
      data.infMDFe.seg[0].infResp.CNPJ =
        data.infMDFe.seg[0].infResp.CNPJ.replace(/[^A-Z0-9]/gi, "");

      if (!errors.valido) {
        console.log("Erros de validação:", errors);
        setTitle("Alguns campos precisam ser modificados");
        setStatus("error");

        setMensagem(errors);
        setOpen(true);
      } else {

        const resposta = await axios.post(
          "https://api-fortio-integr-nuvem-fiscal-323958413561.us-central1.run.app/api/send-mdfe",
          data
        );




        if (resposta.status === 200) {
          updateMdfeStatus(resposta.data, idMdfe);

          setTitle("Erro ao enviar MDF-e");
          setStatus("error");
          setMensagem("Erro ao enviar MDFe: " + resposta.data);
          setOpen(true);
        } else {
          setTitle("Erro ao enviar MDF-e");
          setStatus("error");
          setMensagem("Erro ao enviar MDFe: " + resposta.data);
          setOpen(true);
        }
        console.log("Todos os campos são válidos!");
      }
    } catch (error) {
      console.error("Erro ao enviar MDFe:", error);

      if (error.response && error.response.data?.error?.message) {
        setTitle("Erro ao enviar MDF-e");
        setStatus("error");
        setMensagem(limparMensagemErro(error.response.data.error.message));
        setOpen(true);
      } else {
        setTitle("Erro ao enviar MDF-e");
        setStatus("error");
        setMensagem(
          error.response?.data.mensagem || "Erro desconhecido ao enviar MDF-e"
        );
        setOpen(true);
      }
    } finally {
      setLoading(false);
    }
  };

  function updateMdfeStatus(data, idMdfe) {

    const update = {
      id: data?.id ? data.id : 0,
      status: data?.status ? data.status : "",
      referencia: data?.referencia ? data.referencia : "",
      serie: data?.serie ? data.serie : "",
      numero: data?.numero ? data.numero : "",
      valor_total: data?.valor_total ? data.valor_total : 0,
      autorizacao: {
        id: data?.autorizacao?.id ? data.autorizacao.id : 0,
        status: data?.autorizacao?.status ? data.autorizacao.status : "",
        autor: data?.autorizacao?.autor?.cpf_cnpj
          ? data.autorizacao.autor.cpf_cnpj
          : "",
        motivo_status: data?.autorizacao?.motivo_status
          ? data.autorizacao.motivo_status
          : "",
        tipo_evento: data?.autorizacao?.tipo_evento
          ? data.autorizacao.tipo_evento
          : "",
        chave_acesso: data?.autorizacao?.chave_acesso
          ? data.autorizacao.chave_acesso
          : "",
        codigo_status: data?.autorizacao?.codigo_status
          ? data.autorizacao.codigo_status
          : "",
        data_evento: data?.autorizacao?.data_evento
          ? data.autorizacao.data_evento
          : new Date(),
        data_recebimento: data?.autorizacao?.data_recebimento
          ? data.autorizacao.data_recebimento
          : new Date(),
        ambiente: data?.autorizacao?.ambiente ? data.autorizacao.ambiente : "",
      },
      created_at: data?.created_at ? data.created_at : new Date(),
      data_emissao: data?.data_emissao ? data.data_emissao : new Date(),
      chave: data?.chave ? data.chave : "",
    };

    const mdfeRef = firebase.firestore().collection("tb_mdfe").doc(idMdfe);
    mdfeRef
      .update({
        retornoSefaz: update,
      })
      .then(() => {
        console.log("MDF-e atualizado com sucesso!");

        if (data?.autorizacao?.status === "rejeitado") {
          setTitle("MDF-e Rejeitado");
          setStatus("error");
          setMensagem(
            "MDF-e rejeitado: " +
            data.autorizacao.motivo_status +
            " (Código: " +
            data.autorizacao.codigo_status +
            ")"
          );
        } else if (data.autorizacao?.codigo_status === 100) {
          updateShipper(idMdfe);

          setTitle("MDF-e Enviado com Sucesso");
          setStatus("success");
          setMensagem(
            "MDF-e enviado com sucesso! Número: " +
            data.numero +
            ", Chave: " +
            data.chave
          );
        }
        setOpen(true);
      })
      .catch((error) => {
        console.error("Erro ao atualizar MDF-e:", error);
        message.error("Erro ao atualizar MDF-e: " + error.message);
        setTitle("Erro ao atualizar MDF-e");
        setStatus("error");
        setMensagem("Erro ao atualizar MDF-e: " + error.message);
        setOpen(true);
      });
  }

  function updateShipper(idMdfe) {


    const mdfe = firebase.firestore().collection("tb_mdfe").doc(idMdfe);

    mdfe
      .get()
      .then((doc) => {
        if (doc.exists) {
          const data = doc.data();

          updateShipperNumber(data.infMDFe.dataOrigin.idShipper);
        } else {
          console.log(
            "Nenhum documento encontrado para o MDF-e com ID:",
            idMdfe
          );
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar MDF-e:", error);
      });
  }

  function updateShipperNumber(idShipper) {
    const mdfeRef = firebase.firestore().collection("shipper").doc(idShipper);

    mdfeRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          const data = doc.data();

          var numberMdfe = parseInt(data.mdfe.number);
          // Incrementa o número do MDF-e
          numberMdfe += 1;

          mdfeRef
            .update({
              "mdfe.number": numberMdfe.toString().padStart(7, "0"),
            })
            .then(() => {
              console.log("Shipper atualizado com sucesso!");
            })
            .catch((error) => {
              console.error("Erro ao atualizar shipper:", error);
            });

          console.log("Dados do shipper:", data);
        } else {
          console.log(
            "Nenhum documento encontrado para o shipper com ID:",
            idShipper
          );
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar shipper:", error);
      });
  }

  function limparMensagemErro(mensagem) {
    var retorno = mensagem.replace(/^Validation failed:\s*/, "");

    if (
      retorno ===
      "O campo 'infMDFe.infModal.rodo.infANTT.infContratante[0].infContrato.vContratoGlobal' deve ser maior que 0"
    ) {
      retorno = "O campo 'Valor do Contrato Global' deve ser maior que 0";
    }

    return retorno;
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="large"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),


    /**
     * onFilter: (value, record) => boolean
     * 
     * Given a value and a record, this function will return true if the value is found in the record.
     * If dataIndex is an array, it will traverse the array and check for the value in each key.
     * If dataIndex is a string, it will check for the value in the record[dataIndex].
     * @param {string} value The value to search for.
     * @param {object} record The record to search in.
     * @returns {boolean} true if the value is found, false otherwise.
     */
    onFilter: (value, record) => {

      if (Array.isArray(dataIndex)) {
        let valorRegistro = record;

        for (let key of dataIndex) {
          valorRegistro = valorRegistro ? valorRegistro[key] : null;
        }
        return valorRegistro
          ? valorRegistro.toString().toLowerCase().includes(value.toLowerCase())
          : false;
      }


      return record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : false;
    },
  });

  const columns = [
    {
      title: "Status",
      key: "status",
      render: (_, record) => {
        // 1. Prioridade máxima: Cancelado
        if (record.retornoSefaz?.canceledMdfe) {
          return <span><Chip label="Cancelado" sx={{
            backgroundColor: "#FA1313FF",
            color: "#ffffff",
            fontWeight: 600
          }} /></span>;
        }
        // 2. Segunda prioridade: Encerrado
        if (record.retornoSefaz?.mdfeFinished) {
          return <span> <Chip label="Encerrado" sx={{
            backgroundColor: "#2ED644FF",
            color: "#ffffff",
            fontWeight: 600
          }} /></span>;
        }

        if (record.retornoSefaz?.status === "autorizado") {
          return <span> <Chip label="Autorizado" sx={{
            backgroundColor: "#0786EEFF",
            color: "#ffffff",
            fontWeight: 600
          }} /></span>;
        }

        if (record.retornoSefaz?.status === "rejeitado") {
          return <span> <Chip label="Inconsistente"
            sx={{
              backgroundColor: "#E9770CFF",
              color: "#ffffff",
              fontWeight: 600
            }}
          /></span>;
        }
        // 3. Padrão
        return <span><Chip label="Normal" sx={{
          backgroundColor: "#6B6B6BFF", color: "#ffffff",
          fontWeight: 600
        }} /></span>;
      },

      sorter: (a, b) => {
        const getStatus = (rec) => {
          if (rec.retornoSefaz?.canceledMdfe) return "Cancelado";
          if (rec.retornoSefaz?.mdfeFinished) return "Encerrado";
          return "Em Aberto";
        };
        return getStatus(a).localeCompare(getStatus(b));
      },
    },

   
    {
      title: "Número",
      key: "nMDF",
      render: (_, record) => <span>{record.infMDFe.ide.nMDF}</span>,
      ...getColumnSearchProps(["infMDFe", "ide", "nMDF"]),
      sorter: (a, b) => {
        const nMdfa = String(a?.infMDFe?.ide?.nMDF ?? "");
        const nMdfb = String(b?.infMDFe?.ide?.nMDF ?? "") || "";
        return nMdfa.localeCompare(nMdfb);
      },
    },

    {
      title: "Embarcador",
      key: "CPF",
      width: "20%",
      render: (_, record) => <span>{record.infMDFe.emit.xNome}</span>,
      ...getColumnSearchProps(["infMDFe", "emit", "xNome"]),
      sorter: (a, b) => {
        const cpfA = a?.infMDFe.emit.xNome || "";
        const cpfB = b?.infMDFe.emit.xNome || "";
        return cpfA.localeCompare(cpfB);
      },
    },
    {
      title: "Data de Emissão",
      key: "dataEmissao",
      width: "4%",
      render: (_, record) => (
        <span>{formatarTimestamp(record.infMDFe.ide.dhEmi)}</span>
      ),
      ...getColumnSearchProps(["infMDFe", "ide", "dhEmi"]),
      sorter: (a, b) => {
        const dataA = a?.infMDFe.ide.dhEmi?.toDate
          ? a.infMDFe.ide.dhEmi.toDate()
          : new Date(0);

        const dataB = b?.infMDFe.ide.dhEmi?.toDate
          ? b.infMDFe.ide.dhEmi.toDate()
          : new Date(0);

        return dataA - dataB;
      },
    },


    {
      title: "Origem ",
      key: "UF",
      render: (_, record) => <span>{record.infMDFe.ide.infMunCarrega[0].xMunCarrega} - {record.infMDFe.ide.UFIni}</span>,
      ...getColumnSearchProps(["infMDFe", "ide", "UFFim"]),
      sorter: (a, b) => {
        const nMdfa = a?.infMDFe.ide.UFFim || "";
        const nMdfb = b?.infMDFe.ide.UFFim || "";
        return nMdfa.localeCompare(nMdfb);
      },
    },
    {

      title: "Destino",
      key: "destino",

      render: (_, record) => <span>{record.infMDFe.infDoc.infMunDescarga[0].xMunDescarga} - {record.infMDFe.ide.UFFim}</span>,
      ...getColumnSearchProps(["infMDFe", "ide", "UFFim"]),
      sorter: (a, b) => {
        const nMdfa = a?.infMDFe.ide.UFFim || "";
        const nMdfb = b?.infMDFe.ide.UFFim || "";
        return nMdfa.localeCompare(nMdfb);
      },

    },

    {
      title: "Placa",
      key: "placa",
      width: "5%",
      render: (_, record) => <span>{record.infMDFe.infModal.rodo.veicTracao.placa}</span>,
    },
    {
      title: "Motorista",
      key: "CPF",
      width: "14%",
      render: (_, record) => (
        <span>{record.infMDFe.infModal.rodo.veicTracao.condutor[0].xNome}</span>
      ),
    },

    {
      title: "Ações",
      width: "10%",
      key: "action",
      render: (_, record) => (
        <Space size="middle">

          {record.retornoSefaz?.status === "autorizado" || !user?.permissoes?.mdfe?.isEdit ? (
            <Link to={'/insertMdfe/' + record.id} state={{ viewOnly: true }}>
              <VisibilityRoundedIcon />
            </Link>
          ) : (
            <Link to={"/insertMdfe/" + record.id} state={{ viewOnly: false }}>
              <EditOutlinedIcon
                titleAccess="Editar MDFe"
                sx={{ fontSize: 25 }}
              />
            </Link>
          )}


          {record.retornoSefaz?.status === "autorizado" ? (
            !record.retornoSefaz?.mdfeFinished && !record.retornoSefaz?.canceledMdfe ? (
              <Link to={"#"}>
                <CancelIcon
                  onClick={(e) => finishMdfe(record)}
                  titleAccess="Encerrar MDF-e"
                  sx={{
                    color: "#FF0000FF", fontSize: 25, transition: 'color 0.2s ease-in-out', '&:hover': {
                      color: '#C00000',
                      filter: 'drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.3))'
                    }
                  }}
                />
              </Link>
            ) : (
              ""
            )
          ) : (
            <Link to={"#"}>
              <SendIcon

                titleAccess="Enviar MDFe "
                onClick={(e) => sendMdfe(record.id)}
                color="primary"
                sx={{
                  fontSize: 25, '&:hover': {
                    color: '#003DC0FF',
                    filter: 'drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.3))'
                  }
                }}
              />
            </Link>
          )}

          {(() => {
            const status = record.retornoSefaz?.status;
            const dataEvento = record.retornoSefaz?.autorizacao?.data_evento
              ? new Date(record.retornoSefaz.autorizacao.data_evento)
              : null;

            let diffHoras = 0;

            if (dataEvento) {
              const agora = new Date();
              diffHoras = (agora - dataEvento) / (1000 * 60 * 60); // diferença em horas
            }

            if (status === "autorizado") {
              // if (diffHoras <= 24) {
              //   return null;
              // }

              if (record.retornoSefaz?.mdfeFinished || record.retornoSefaz?.canceledMdfe) {
                return null
              }

              return (
                <CancelScheduleSendSharpIcon
                  titleAccess="Cancelar MDFe"
                  sx={{
                    color: "#FFC400FF", fontSize: 26, '&:hover': {
                      color: '#B99E04FF',
                      filter: 'drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.3))'
                    }
                  }}

                  onClick={(e) => cancelMdfe(record)}
                />
              );
            }

            return (
              <>
                {user?.permissoes?.mdfe?.isDelete ||
                  user?.permissoes?.mdfe?.excluir ? (
                  <Link to={"#"}>
                    <DeleteOutlinedIcon
                      titleAccess="Excluir MDFe"
                      onClick={() => deleteMdfe(record.id)}
                      color="error"
                    />
                  </Link>
                ) : (
                  ""
                )}
              </>
            );


          })()}
          <Link to={"#"}>
            <InfoIcon
              titleAccess="Informação MDFe"
              onClick={(e) => getInformation(record.id)}
              color="primary"
              sx={{
                fontSize: 25,
                cursor: "pointer",
              }}
            />
          </Link>
        </Space>
      ),
    },
  ];



  return (
    <>
     {/* <Spin spinning={loading} size="large"> */}
      <Table columns={columns} dataSource={data} loading={loading} />
    {/* </Spin> */}
      

      <RetornoMdfeModal
        open={open}
        setOpen={setOpen}
        mensagem={mensagem}
        title={title}
        status={status}
      />
    </>
  );
};

export default DataMdfeCompTable;
